import React, { useState, useRef } from "react";

export default function IshaChat({ cancerName = "Cancer" }) {
  const [chatOpen, setChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([
    { from: "Isha", text: "Hello! How can I help you?" },
  ]);
  const [chatInput, setChatInput] = useState("");
  const chatBodyRef = useRef(null);

  const handleSendChat = () => {
    const msg = chatInput.trim();
    if (!msg) return;
    setChatMessages((prev) => [...prev, { from: "You", text: msg }]);
    setChatInput("");
    setTimeout(() => {
      if (chatBodyRef.current)
        chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }, 50);
  };

  return (
    <>
      {/* Trigger button */}
      <div
        className="cus-chat-box position-fixed"
        style={{ right: 0, top: "80%", zIndex: 9999, transform: "translateY(-50%)" }}
        onClick={() => setChatOpen((prev) => !prev)}
      >
        Ask Isha
      </div>

      {/* Chat popup */}
      {chatOpen && (
        <div className="chat-popup" style={{ display: "block" }}>
          <div className="chat-header">
            Let&apos;s Deep Dive {cancerName}
            <button
              className="btn btn-sm btn-danger float-end"
              onClick={() => setChatOpen(false)}
            >
              &times;
            </button>
          </div>
          <div className="chat-body" ref={chatBodyRef}>
            {chatMessages.map((m, i) => (
              <p key={i}>
                <strong>{m.from}:</strong> {m.text}
              </p>
            ))}
          </div>
          <div className="chat-footer">
            <input
              type="text"
              className="form-control"
              placeholder="Ask Here..."
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendChat()}
            />
            <button className="btn btn-primary" onClick={handleSendChat}>
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
}
